import { Component, Input, OnInit, inject } from "@angular/core";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { FindingReportSummaryModel } from "@app/moi/shared/finding-report-summary-model";
import { MoiModel } from "@models/moi/MoiModel";
import { AssessmentSummaryModel } from "@app/moi/shared/assessment-summary-model";
import { MoiDataService } from "@app/moi/services/moi-data.service";
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/moi/i18n/scope";
import { FormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgSelectModule } from "@ng-select/ng-select";
import { DateInputComponent } from "@app/shared/components/date-input/date-input.component";
import { InputTooltipDirective } from "@app/shared/directives/input-tooltip.directive";
import { DateFormatPipe } from "@app/shared/pipes/date-format.pipe";

@Component({
    selector: "moi-finding-report-summary",
    templateUrl: "./moi-finding-report-summary.component.html",
    styleUrls: ["./moi-finding-report-summary.component.scss"],
    imports: [
        TranslatePipe,
        FormsModule,
        MatTooltipModule,
        NgSelectModule,
        DateInputComponent,
        InputTooltipDirective,
        DateFormatPipe,
    ],
    viewProviders: [provideTranslationScope(scope)],
})
export class MoiFindingReportSummaryComponent implements OnInit {
    private tabservice = inject(TabService);
    private pages = inject(Pages);
    private _moiDS = inject(MoiDataService);

    @Input() summaryModel: FindingReportSummaryModel;
    @Input() showOpenButton: false;
    @Input() moi: MoiModel;
    @Input() canLink: boolean;

    assessments: AssessmentSummaryModel[];
    assessmentModel: AssessmentSummaryModel;
    assessmentIsLoading: boolean;

    ngOnInit() {
        this.load();
    }

    load() {
        this.assessments = null;
        this.assessmentModel = null;
        this.assessmentIsLoading = true;

        if (this.moi.AssessmentGuid) {
            this._moiDS
                .getAssessmentSummary(this.moi.AssessmentGuid)
                .subscribe((summary: AssessmentSummaryModel) => {
                    this.assessmentModel = summary;
                    this.assessmentIsLoading = false;
                });
        } else {
            this._moiDS
                .getAssessmentsByFindingReport(this.moi.ParentId)
                .subscribe((assessments) => {
                    this.assessments = assessments;
                    this.assessmentIsLoading = false;
                });
        }
    }

    change(event) {
        this.assessmentModel = event;
    }

    linkAssessment() {
        if (this.assessmentModel) {
            this.moi.AssessmentGuid = this.assessmentModel.guid;
        }
    }

    openAssessment() {
        if (!this.assessmentModel.id) {
            return;
        }

        this.tabservice.generateTab(this.pages.AssessmentDetail, this.assessmentModel.guid, null, {
            parentGuid: this.assessmentModel.findingReportGuid,
        });
    }

    openFindingReport() {
        if (!this.summaryModel.id) {
            return;
        }

        this.tabservice.generateTab(this.pages.ImDetail, this.summaryModel.guid);
    }
}
